import React, { useEffect, useState } from 'react';
import './ShimmerMenu.scss';

const SHIMMER_ITEM_HEIGHT = 30;

const ShimmerMenuList = () => {
    const [itemCount, setItemCount] = useState(3);

    useEffect(() => {
        const updateCount = () => {
            const availableHeight = window.innerHeight - 100; // adjust if header/footer present
            const count = Math.floor(availableHeight / SHIMMER_ITEM_HEIGHT);
            setItemCount(count);
        };

        updateCount();
        window.addEventListener('resize', updateCount);
        return () => window.removeEventListener('resize', updateCount);
    }, []);

    return (
        <div className="shimmer-menu-list">
            <div>
                {Array.from({ length: itemCount }).map((_, i) => (
                    <div className="shimmer-item" key={i}>
                        <div className="shimmer-item-child" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ShimmerMenuList;
